import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';
@Injectable()
export class UserService {

  constructor(private http: HttpClient) { }
  saveInsuser(institution, name, mobile_number, email, role_id, role_type) {
    var formData = {
      'institution': institution,
      'name': name,
      'mobile_number': mobile_number,
      'email': email,
      'role_id': role_id,
      'role_type': role_type
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin/create`, formData).pipe(map(user => {
      return user;
    }));
  }

  setting(slot,event, day,event_time ) {
    var formData = {
      'event': slot,
      'day': day,
      'event_slot':event,
      // 'event_time':event_time
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/settings/gate-close-create`, formData).pipe(map(user => {
      return user;
    }));
  }

  updatecolumn(event,rows,columndate ) {
    var formData = {
      'total_rows': rows,
      'event_slot': event,
      'event':columndate
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/settings/no-seats-create`,formData).pipe(map(user => {
      return user;
    }));
  }

  // columns(event, day, ) {
  //   var formData = {
  //     'event': event,
  //     'day': day,
  //   }
  //   return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/settings/gate-close-create`, formData).pipe(map(user => {
  //     return user;
  //   }));
  // }

  

  updateInsuser(id,institution, name, mobile_number, email, role_id, role_type) {
    var formData = {
      'institution': institution,
      'name': name,
      'mobile_number': mobile_number,
      'email': email,
      // 'role_id': role_id,
      // 'role_type': role_type
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin/update/`+id, formData).pipe(map(user => {
      return user;
    }));
  }



  saveFooduser(name, mobile_number, email, role_id, role_type) {
    var formData = {
      'name': name,
      'mobile_number': mobile_number,
      'email': email,
      'role_id': role_id,
      'role_type': role_type
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin/create-venue-users`, formData).pipe(map(user => {
      return user;
    }));
  }

  updateFooduser(id,name, mobile_number, email, role_id, role_type) {
    var formData = {
      'name': name,
      'mobile_number': mobile_number,
      'email': email,
      // 'role_id': role_id,
      // 'role_type': role_type
    }
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin/update-venue-users/` + id, formData).pipe(map(user => {
      return user;
    }));
  }

  getInsuser(page, search, role_type): Observable<any> {
    if (!search) {
      search = '';
    }
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin?role_type=` + role_type + '&page=' + page + '&search=' + search).pipe(map(user => user));
  }
  getInsuserfilter(page, search,institution, role_type): Observable<any> {
    if (!search) {
      search = '';
    }
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin?role_type=` + role_type + '&page=' + page + '&search=' + search+ '&institution=' + institution).pipe(map(user => user));
  }


  getInstitute(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/institute`).pipe(map(user => user));
  }

  uploadInsuser(file: File, id: any, type: any) {
    const formData: FormData = new FormData();
    if (file) {
      formData.append('file', file, file.name);
      formData.append('role_id', id);
      formData.append('role_type', type);
      return this.http
        .post<any>(
          ` ${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin/create-excel`,
          formData
        )
        .pipe(
          map((user) => {
            return user;
          })
        );
    }

  }

  uploadFooduser(file: File, id: any, type: any) {
    const formData: FormData = new FormData();
    if (file) {
      formData.append('file', file, file.name);
      formData.append('role_id', id);
      formData.append('role_type', type);
      return this.http
        .post<any>(
          ` ${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin/create-excel-venue-users`,
          formData
        )
        .pipe(
          map((user) => {
            return user;
          })
        );
    }
  }

  deleteUser(id: string) {
    return this.http.delete<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin/delete-users/` + id).pipe(map(user => {
        return user;
    }));
}

deleteAllUser(type: string) {
  var formData = {
    'type': type,
  }
  return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin/delete-all-users` ,formData).pipe(map(user => {
      return user;
  }));
}

  getEvents(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/events`).pipe(map(user => user));
  }

  getcloselist(id): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/settings/gate-close/`+id).pipe(map(user => user));
  }

  getrowcount(event,id): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/settings/no-of-seats/`+id+'?event_slot='+event).pipe(map(user => user));
  }

  getGateCloseList(id,slotid): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/settings/gate-close/`+id+'?event_slot='+slotid).pipe(map(user => user));
  }

  seatallotment(id,date): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/seatings/generate-seats/`+date+'?event_slot='+id).pipe(map(user => user));
  }

  generateSeat(id): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/seatings/generate-seats/`+ id).pipe(map(user => user));
  }

  getVenueuser(page, search, role_type): Observable<any> {
    if (!search) {
      search = '';
    }
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/sub-admin/venue-food-users?role_type=` + role_type + '&page=' + page + '&search=' + search).pipe(map(user => user));
  }

}
